<template>
    <div class="step-box">
        <div class="tips-area text-center">
            <div class="tips-area__icon">
                <i class="el-icon-check"></i>
            </div>
            <div class="tips-area__msg">
                批量发布项目成功
            </div>
            <div class="tips-area__footer">
                <el-button
                    @click="
                        goPage(
                            `/index/project`
                        )
                    "
                    type="primary"
                    >查看</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step3',
    inject: ['back', 'goPage', 'tel']
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var";
@import "../../assets/style/sub";
.tips-area {
    margin-top: 114px;
    .tips-area__icon {
        display: inline-block;
        border-radius: 50%;
        color: #fff;
        line-height: 108px;
        font-size: 48px;
        width: 100px;
        height: 100px;
        background-color: $--color-primary;
    }
    .tips-area__msg {
        margin-top: 28px;
        font-size: 16px;
        font-weight: 700;
    }
    .tips-area__desc {
        margin-top: 10px;
    }
    .tips-area__footer {
        max-width: 130px;
        margin: 56px auto 0;
        button {
            width: 100%;
        }
    }
}
</style>
